"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MultiplicityType_1 = require("../models/parameters/MultiplicityType");
const SingleValueParameter_1 = require("../models/parameters/SingleValueParameter");
const MultiValueParameter_1 = require("../models/parameters/MultiValueParameter");
class ParametersCollection {
    constructor(parametersInfo, onParameterChange) {
        this._onParameterChange = onParameterChange;
        this._parametersDict = new Map();
        parametersInfo.forEach((x) => this.add(x));
    }
    get parameters() {
        const result = Array.from(this._parametersDict.values());
        return result;
    }
    get(id) {
        const result = this._parametersDict.get(id);
        return result;
    }
    add(paramInfo) {
        let parameter;
        const { id, type, allowNullable, multiplicityType, value } = paramInfo;
        const raisePropertyChanged = this._onParameterChange;
        const alreadyExist = this._parametersDict.has(id);
        if (alreadyExist) {
            throw `Parameter ${id} already exist`;
        }
        switch (multiplicityType) {
            case MultiplicityType_1.MultiplicityType.Single:
                parameter = new SingleValueParameter_1.SingleValueParameter(id, type, allowNullable, value, raisePropertyChanged);
                break;
            case MultiplicityType_1.MultiplicityType.Multiple:
                parameter = new MultiValueParameter_1.MultiValueParameter(id, type, allowNullable, value, raisePropertyChanged);
                break;
            default:
                throw `unknown parameter multiplicity type ${multiplicityType}`;
        }
        this._parametersDict.set(id, parameter);
    }
}
exports.ParametersCollection = ParametersCollection;
//# sourceMappingURL=ParametersCollection.js.map